import lowerFloor from "./plan-2np-3d.jpg.asset.json";
import upperFloor from "./plan-3np-3d.jpg.asset.json";

const photoModules = import.meta.glob("./img-*.jpg.asset.json", {
  eager: true,
  import: "default",
}) as Record<string, { url: string }>;

export const mnichoviceBytImages = Object.entries(photoModules)
  .sort(([a], [b]) => a.localeCompare(b))
  .map(([, asset]) => asset.url);

export const mnichoviceBytFloorPlans = [
  { image: lowerFloor.url, label: "2. NP – 3D" },
  { image: upperFloor.url, label: "3. NP – 3D" },
];